import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Overview from './components/Overview';
import Specifications from './components/Specifications';
import Gallery from './components/Gallery';
import WhyUnique from './components/WhyUnique';
import PotentialUses from './components/PotentialUses';
import Location from './components/Location';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CTAButtons from './components/CTAButtons';
import Admin from './components/Admin';
import AuthCallback from './components/AuthCallback';
import PrivacyPolicy from './components/PrivacyPolicy';
import DataDeletion from './components/DataDeletion';
import Blog from './components/Blog';
import BlogArticle from './components/BlogArticle';
import CookieConsent from './components/CookieConsent';
import ChatWidget from './components/ChatWidget';

const Home = () => {
  // Handle hash-based navigation (e.g., /#contact)
  React.useEffect(() => {
    if (window.location.hash === '#contact') {
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <Overview />
      <Specifications />
      <Gallery />
      <WhyUnique />
      <PotentialUses />
      
      {/* CTA Section After Gallery */}
      <section className="py-12 sm:py-16 bg-white">
        <CTAButtons showDownload={true} />
      </section>
      
      <Location />
      <FAQ />
      <Contact />
      
      {/* Final CTA at Bottom */}
      <section className="py-12 sm:py-16 bg-slate-50">
        <CTAButtons showDownload={true} />
      </section>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
};

// Router component that checks for session_id in URL hash
const AppRouter = () => {
  // Check URL fragment for session_id (from Google OAuth redirect)
  // Use window.location.hash directly as React Router may not capture it correctly
  const hash = window.location.hash;
  
  // Debug logging
  console.log('AppRouter - Current hash:', hash);
  console.log('AppRouter - Full URL:', window.location.href);
  
  if (hash?.includes('session_id=')) {
    console.log('AppRouter - Found session_id, rendering AuthCallback');
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogArticle />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
            <CookieConsent />
            <ChatWidget />
          </BrowserRouter>
          <Toaster position="top-center" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
